<template lang="pug">
  v-container.pa-0
    v-snackbar( v-model="showSnackBar" :color="snackBarColor" ) {{snackBarMessage}}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="showSnackBar = false")
          v-icon fal fa-times
    v-dialog(v-model="showFoodDialog" max-width="800"  persistent scrollable :fullscreen="!showExtended"
      v-if="showFoodDialog" )
      v-card.pa-0(height="800px")
        v-card-title.headline.px-0
          span.pl-3 {{ dialogTitle }}
          v-tabs(v-model="tab")
            v-tab {{ $t('foodDatabasePage.propertiesLabel') }}
            v-tab(:disabled="!isUpdate") {{ $t('foodDatabasePage.recipeTitle') }}
            v-tab(:disabled="!isUpdate") {{ $t('foodDatabasePage.imagesLabel') }}
        v-card-text.pa-0
          v-tabs-items(v-model="tab" touchless)
            v-tab-item
              v-card-text(v-if="this.$vuetify.breakpoint.mdAndUp" style="height: 580px; overflow-y: scroll")
                v-form(v-model="formIsValid" ref="foodForm" lazy-validation @submit.prevent="onFormSubmit")
                  v-row
                    v-col.pb-0(cols="12")
                      v-textarea(validate-on-blur v-model="foodItemName" outlined
                      :label="$t('foodDatabasePage.foodNameFieldPlaceholder')"
                        auto-grow rows="2" :rules="foodNameValidationRules" autofocus)
                      v-select(
                        :rules="selectedTag"
                        :items="tagCollection"
                        :label="$t('settingsPage.labelLabel')"
                        item-text="title"
                        item-value="id"
                        v-model="selectedTagCollection"
                        color="primary"
                        multiple
                        :readonly="isSelectionTagReadOnly && selectedTagCollection.length > 0"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                        outlined
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            v-icon.mr-4(left) {{ tagButtonIcon(item) }}
                            span {{ item.title }}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title
                                v-icon.mr-4 {{ tagButtonIcon(item) }}
                                span {{ item.title }}

                    v-col.pb-0(cols="12")
                      v-textarea(:label="$t('foodDatabasePage.description')" full-width auto-grow v-model="text" outlined)
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.priceLabel')"
                        :hint="$t('foodDatabasePage.priceHintLabel')"
                        outlined
                        append-icon="fas fa-euro-sign"
                        v-model="price"
                        :rules="priceRules")
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.weightLabel')"
                        v-model="weight"
                        outlined
                        :hint="$t('foodDatabasePage.weightHintLabel')"
                        :rules="priceRules")
                    v-row.ma-0
                      v-col.pb-0(cols="6")
                        v-text-field(
                          :label="$t('foodDatabasePage.energyValueLabel')"
                          outlined
                          v-model="energyValue"
                          :rules="priceRules"
                        )
                      v-col.pb-0(cols="6")
                        v-select(
                          v-model="energyValueStatus"
                          :items="energyList"
                          :label="$t('foodDatabasePage.value')"
                          outlined
                          append-icon="fas fa-chevron-down"
                          @change="changeEnergyValue"
                        )
                          template(v-slot:item="{active, item, attrs, on }")
                            v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                              v-list-item-action
                                v-checkbox(
                                  :input-value="active"
                                  on-icon="fas fa-check-square"
                                  off-icon="far fa-square" )
                              v-list-item-content
                              v-list-item-title {{item}}

                    v-col(cols="12")
                      v-select(:label="$t('foodDatabasePage.allergensLabel')" outlined multiple
                      :loading="fetchInProgress"
                        :items="allergensList"
                        item-text="title"
                        item-value="id"
                        v-model="selections"
                        color="primary"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            span {{item.code}}. {{item.shortTitle}}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title {{item.code}}. {{item.title}}

              v-card-text(v-else-if="this.$vuetify.breakpoint.sm" style="height: 100vh; overflow-y: scroll")
                v-form(v-model="formIsValid" ref="foodForm" lazy-validation @submit.prevent="onFormSubmit")
                  v-row
                    v-col.pb-0(cols="12")
                      v-textarea(validate-on-blur v-model="foodItemName" outlined
                      :label="$t('foodDatabasePage.foodNameFieldPlaceholder')"
                        auto-grow rows="2" :rules="foodNameValidationRules" autofocus)
                      v-select(
                        :items="tagCollection"
                        :label="$t('settingsPage.labelLabel')"
                        item-text="title"
                        item-value="id"
                        v-model="selectedTagCollection"
                        color="primary"
                        multiple
                        :readonly="isSelectionTagReadOnly && selectedTagCollection.length > 0"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                        outlined
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            v-icon.mr-4(left) {{ tagButtonIcon(item) }}
                            span {{ item.title }}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title
                                v-icon.mr-4 {{ tagButtonIcon(item) }}
                                span {{ item.title }}

                    v-col.pb-0(cols="12")
                      v-textarea(:label="$t('foodDatabasePage.description')" full-width auto-grow v-model="text" outlined)
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.priceLabel')"
                        :hint="$t('foodDatabasePage.priceHintLabel')"
                        outlined
                        append-icon="fas fa-euro-sign"
                        v-model="price"
                        :rules="priceRules")
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.weightLabel')"
                        v-model="weight"
                        outlined
                        :hint="$t('foodDatabasePage.weightHintLabel')"
                        :rules="priceRules")
                  v-row.ma-0
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.energyValueLabel')"
                        outlined
                        v-model="energyValue"
                        :rules="priceRules"
                      )
                    v-col.pb-0(cols="6")
                      v-select(
                        v-model="energyValueStatus"
                        :items="energyList"
                        :label="$t('foodDatabasePage.value')"
                        outlined
                        append-icon="fas fa-chevron-down"
                        @change="changeEnergyValue"
                      )
                          template(v-slot:item="{active, item, attrs, on }")
                            v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                              v-list-item-action
                                v-checkbox(
                                  :input-value="active"
                                  on-icon="fas fa-check-square"
                                  off-icon="far fa-square" )
                              v-list-item-content
                              v-list-item-title {{item}}

                    v-col(cols="12")
                      v-select(:label="$t('foodDatabasePage.allergensLabel')" outlined multiple
                      :loading="fetchInProgress"
                        :items="allergensList"
                        item-text="title"
                        item-value="id"
                        v-model="selections"
                        color="primary"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            span {{item.code}}. {{item.shortTitle}}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title {{item.code}}. {{item.title}}
              v-card-text(v-else style="height:66vh; overflow-y: scroll")
                v-form(v-model="formIsValid" ref="foodForm" lazy-validation @submit.prevent="onFormSubmit")
                  v-row
                    v-col.pb-0(cols="12")
                      v-textarea(v-model="foodItemName" validate-on-blur outlined :label="$t('foodDatabasePage.foodNameFieldPlaceholder')" auto-grow rows="2" :rules="foodNameValidationRules" autofocus)
                      v-select(
                        :items="tagCollection"
                        :label="$t('settingsPage.labelLabel')"
                        item-text="title"
                        item-value="id"
                        v-model="selectedTagCollection"
                        color="primary"
                        multiple
                        :readonly="isSelectionTagReadOnly && selectedTagCollection.length > 0"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                        outlined
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            v-icon.mr-4(left) {{ tagButtonIcon(item) }}
                            span {{ item.title }}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title
                                v-icon.mr-4 {{ tagButtonIcon(item) }}
                                span {{ item.title }}

                    v-col.pb-0(cols="12")
                      v-textarea(:label="$t('foodDatabasePage.description')" hide-details full-width auto-grow v-model="text" outlined )
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.priceLabel')"
                        :hint="$t('foodDatabasePage.priceHintLabel')"
                        outlined
                        append-icon="fas fa-euro-sign"
                        v-model="price"
                        :rules="priceRules")
                    v-col.pb-0(cols="6")
                      v-text-field(
                        :label="$t('foodDatabasePage.weightLabel')"
                        v-model="weight"
                        outlined
                        :hint="$t('foodDatabasePage.weightHintLabel')"
                        :rules="priceRules")
                    v-row.ma-0
                      v-col.pb-0(cols="6")
                        v-text-field(
                          :label="$t('foodDatabasePage.energyValueLabel')"
                          outlined
                          v-model="energyValue"
                          :rules="priceRules"
                        )
                      v-col.pb-0(cols="6")
                        v-select(
                          v-model="energyValueStatus"
                          :items="energyList"
                          :label="$t('foodDatabasePage.value')"
                          outlined
                          append-icon="fas fa-chevron-down"
                          @change="changeEnergyValue"
                        )
                          template(v-slot:item="{active, item, attrs, on }")
                            v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                              v-list-item-action
                                v-checkbox(
                                  :input-value="active"
                                  on-icon="fas fa-check-square"
                                  off-icon="far fa-square" )
                              v-list-item-content
                              v-list-item-title {{item}}

                    v-col(cols="12")
                      v-select(:label="$t('foodDatabasePage.allergensLabel')" outlined multiple
                      :loading="fetchInProgress"
                        :items="allergensList"
                        item-text="title"
                        item-value="id"
                        v-model="selections"
                        color="primary"
                        append-icon="fas fa-chevron-down"
                        chips
                        return-object
                      )
                        template( v-slot:selection="{ item, index }")
                          v-chip
                            span {{item.code}}. {{item.shortTitle}}
                        template(v-slot:item="{active, item, attrs, on }")
                          v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                            v-list-item-action
                              v-checkbox(
                                :input-value="active"
                                on-icon="fas fa-check-square"
                                off-icon="far fa-square" )
                            v-list-item-content
                              v-list-item-title {{item.code}}. {{item.title}}
              v-card-actions.pr-4
                v-spacer
                v-btn( color="primary" type="submit" @click="onFormSubmit"
                  :disabled="!formIsValid" :loading="isSaveInProgress") {{ dialogSaveButtonLabel }}
            v-tab-item
              v-container.py-0
                v-card(flat fluid)
                  v-card-text.pa-0.pt-4.pb-4(v-if="this.$vuetify.breakpoint.mdAndUp")
                    v-textarea(v-if="this.$vuetify.breakpoint.mdAndUp" full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="550" hide-details)
                    v-textarea(v-else-if="this.$vuetify.breakpoint.sm" full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="150" hide-details)
                    v-textarea(v-else full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="470" hide-details)
                  v-card-text.pa-0.pt-4.pb-4(v-else style="height:66vh; overflow-y: scroll" )
                    v-textarea(v-if="this.$vuetify.breakpoint.mdAndUp" full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="420" hide-details)
                    v-textarea(v-else-if="this.$vuetify.breakpoint.sm" full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="150" hide-details)
                    v-textarea(v-else full-width auto-grow :label="$t('foodDatabasePage.recipeLabel')" v-model="recipe" outlined height="470" hide-details)
                  v-card-actions.pr-0
                    v-spacer
                    v-btn( color="primary" type="submit" @click="onFormSubmit"
                      :disabled="!formIsValid" :loading="isSaveInProgress") {{ dialogSaveButtonLabel }}
            v-tab-item
              FoodImageGallery(:selectedFood="selectedFood" @closeButtonDisabled="closeButtonDisabled")

        v-divider
        v-card-actions
          v-spacer
          v-btn( text color="primary" :disabled="isSaveInProgress || isCloseButtonDisabled" @click="onCloseButtonClick") {{ $t('buttons.closeButtonLabel') }}

</template>

<script lang="ts">
import {Component, Prop, Watch} from "vue-property-decorator";
import FoodItem from "@/model/food-database/FoodItem";
import Tag from "@/model/tennant/Tag";
import i18n from "@/plugins/i18n";
import {TranslateResult} from "vue-i18n";
import {
  DELETE_FOOD_ITEM_IMAGE,
  FETCH_FOOD_ITEM_IMAGES,
  FOOD_DATABASE_CREATE_FOOD_ITEM,
  FOOD_DATABASE_UPDATE_FOOD_ITEM, SAVE_NEW_FOODITEM_IMAGE, UPDATE_FOOD_ITEM_IMAGE
} from "@/store/action-types";
import Vue from "vue";
import Allergen from "@/model/food-database/Allergen";
import _ from "lodash";
import {Action} from "vuex-class";
import draggable from "vuedraggable";
import index from "vuex";
import FoodItemImage from "@/model/food-database/FoodItemImage";
import {SaveNewImagePayload, UpdateImageList} from "@/types/payload";
import FoodImageGallery from "@/components/dailymenu/detail/FoodImageGallery.vue";

function valueIsRequired (v: string): boolean | TranslateResult {
  return v.length > 0 || i18n.t('validation.valueIsRequired')
}

@Component({
  computed: {
    index() {
      return index
    }
  },
  components: {
    draggable,
    FoodImageGallery
  }
})

export default class FoodDialog extends Vue {

  @Prop({type: Boolean, default: false}) showFoodDialog!: boolean
  @Prop({type: Boolean, default: false}) isSelectionTagReadOnly!: boolean
  @Prop({type: Array as () => any[] | null}) tagCollection!: any[]
  @Prop({type: Object as () => FoodItem}) currentFoodItem!: FoodItem
  @Prop({type: String}) searchTerm?: string
  @Prop({type: Array as () => Tag[] | null}) subGroupTags?: Tag[]
  @Prop({type: Array as () => FoodItem[]}) itemCollection!: FoodItem[]
  @Prop({type: Array as () => Allergen[]}) allergensList!: Allergen[]
  @Action(SAVE_NEW_FOODITEM_IMAGE) saveNewFoodItemImage!: ({ (payload: SaveNewImagePayload | null): Promise<FoodItemImage> })
  @Action(FETCH_FOOD_ITEM_IMAGES) fetchFoodItemImageList!: ({ (payload: any): Promise<any> })
  @Action(DELETE_FOOD_ITEM_IMAGE) deleteFoodImage!: ({ (payload: any): Promise<any> })
  @Action(UPDATE_FOOD_ITEM_IMAGE) updateFoodItemImage!: ({ (payload: UpdateImageList): Promise<any> })


  private selectedTagCollection: Tag[] = []

  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: TranslateResult | null = null
  private formIsValid: boolean = false
  private foodItemName: string = ''
  private isSaveInProgress: boolean = false
  private selections: Allergen[] = []
  private recipe: string = ''
  private energyList: string[] = ['Kcal', 'Kj']
  private energyValue: string = ''
  private energyValueStatus: string = ''
  private price: string = ''
  private weight: string = ''
  private text: string = ''
  private filteredItemCollection: FoodItem[] = []
  private filterText: string = ''
  private filterTag: Tag[] = []
  private fetchInProgress: boolean = false
  private priceRules: Function[] = [
    this.valueMustBeNumber,
    this.valueMustBePositiveNumber
  ]
  private isUpdate: boolean =false
  private selectedFood : any | null = null
  private tab: number | null = null
  private selectedTag = [
    valueIsRequired
  ]

  private foodNameValidationRules: Function[] = [
    (v: string): boolean | string => !!(v && v.trim()) || i18n.t('foodDatabasePage.foodNameIsRequiredError').toString(),
    // @ts-ignore
    this.checkForDuplicities
  ]
  private isCloseButtonDisabled: boolean = false

  valueMustBeNumber(v: string): boolean | TranslateResult {
    if (v) {
      const parsed = parseFloat(v)

      if (!Number.isFinite(parsed)) {
        return i18n.t('validation.valueMustBeNumber')
      }
    }

    return true
  }

  valueMustBePositiveNumber(v: string): boolean | TranslateResult {
    if (v) {
      const parsed = parseFloat(v)

      if (parsed <= 0) {
        return i18n.t('validation.valueMustBePositiveNumber')
      }
    }

    return true
  }

  @Watch('isUpdate')
  watchIsUpdate (newVal: boolean) {
    if (!newVal ) {
      this.isUpdate = newVal
    }
  }

  @Watch('isCloseButtonDisabled')
  watchIsCloseButtonDisabled (newVal: boolean) {
    if (!newVal ) {
      this.isCloseButtonDisabled = newVal
    }
  }

  closeButtonDisabled (item: boolean) {
    if(item) {
      this.isCloseButtonDisabled = true
    } else {
      this.isCloseButtonDisabled = false
    }
  }


  get showExtended(): boolean {
    return this.$vuetify.breakpoint.mdAndUp
  }

  get filterTextPlaceholder(): TranslateResult {
    if (this.showExtended) {
      return this.$t('foodDatabasePage.searchFiledLabelExtended')
    }

    return this.$t('foodDatabasePage.searchFiledLabelShort')
  }

  get dialogTitle(): TranslateResult | null {
    if (this.currentFoodItem && this.currentFoodItem.id > 0 || this.isUpdate) {
      return this.$t('foodDatabasePage.editDialogExistingFoodTitle')
    }

    return this.$t('foodDatabasePage.editDialogNewFoodTitle')
  }

  get dialogSaveButtonLabel(): TranslateResult {
    if (this.currentFoodItem && this.currentFoodItem.id > 0) {
      return this.$t('foodDatabasePage.editDialogExistingFoodSaveButtonLabel')
    }

    return this.$t('foodDatabasePage.editDialogNewFoodSaveButtonLabel')
  }

  get validationRules(): Function[] {
    if (this.currentFoodItem && this.currentFoodItem.id > 0) {
      return []
    }

    return [
      (v: string): boolean | string => !!(v && v.trim()) || i18n.t('foodDatabasePage.foodNameIsRequiredError').toString()
    ]
  }

  isTagInSubgroup(): any {
    return this.tagCollection.filter(tag1 => {
      return this.subGroupTags?.some(tag2 => {
        return tag1.id === tag2.id;
      })
    })
  }

  tagButtonIcon(tagItem: Tag): string | null {
    return tagItem.iconClass
  }

  validateForm(): boolean {
    const form: any = this.$refs['foodForm']

    const hasAtLeastOneTag = this.selectedTagCollection.length > 0

    if (!hasAtLeastOneTag) {
      this.snackBarMessage = this.$t('foodDatabasePage.emptyTagsError')
      this.showSnackBar = true
    } else {
      this.showSnackBar = false
    }

    return form.validate() && hasAtLeastOneTag
  }

  resetDialogState(): void {

    this.selectedTagCollection = []
    this.foodItemName = ''
    this.weight = ''
    this.price = ''
    this.energyValue = ''
    this.energyValueStatus = ''
    this.selections = []
    this.recipe = ''
    this.text = ''
  }

  async onFormSubmit(item?: any): Promise<void> {
    if (this.validateForm()) {
      const foodItem = FoodItem.createFromModel({

        id: this.isUpdate ? this.selectedFood.id :  this.currentFoodItem!.id,
        createdAt: new Date,
        name: this.foodItemName!,
        price: this.price ? this.price : '',
        title: this.foodItemName!,
        description: this.text ? this.text : '',
        energy: this.energyValue + ' ' + this.energyValueStatus ? this.energyValue + ' ' + this.energyValueStatus : '',
        weight: this.weight ? this.weight : '',
        tags: this.selectedTagCollection,
        allergens: this.selections,
        recipe: this.recipe ? this.recipe : '',
        energyUnit: this.energyValue + ' ' + this.energyValueStatus,
        media: []
      })
      try {
        this.isSaveInProgress = true
        let newFoodItem: FoodItem
        if (foodItem.id === 0 && !this.isUpdate) {
          newFoodItem = await this.$store.dispatch(FOOD_DATABASE_CREATE_FOOD_ITEM, foodItem)
          this.isUpdate = true
          this.selectedFood = newFoodItem

          if (this.itemCollection) {
            this.itemCollection.push(newFoodItem)
            this.filteredItemCollection = this.filterItemCollection()
          }
          this.isUpdate = true
          this.tab = 2
          this.showSnackBar = true
          this.snackBarColor = "success"
          this.snackBarMessage = this.$t('foodDatabasePage.foodItemWasCreatedMessage')

        } else {
          newFoodItem = await this.$store.dispatch(FOOD_DATABASE_UPDATE_FOOD_ITEM, foodItem)
          if (this.itemCollection) {
            const idx = _.findIndex(this.itemCollection, {id: newFoodItem.id})
            this.itemCollection.splice(idx, 1, newFoodItem)
            this.filteredItemCollection = this.filterItemCollection()
          }
          this.showSnackBar = true
          this.snackBarColor = "success"
          this.snackBarMessage = this.$t('foodDatabasePage.foodItemWasUpdatedMessage')
        }
      } catch (err) {
        this.snackBarColor = "error"
        this.snackBarMessage = this.$t('foodDatabasePage.foodItemSaveErrorMessage')
        this.showSnackBar = true
      } finally {
        this.isSaveInProgress = false
      }
    } else {
      this.snackBarColor = "error"
      this.snackBarMessage = this.$t('foodDatabasePage.foodItemSaveErrorMessage')
      this.showSnackBar = true
    }
  }

  filterItemCollection(): FoodItem[] {
    if (this.itemCollection) {
      return _.chain(this.itemCollection)
          .filter((i: FoodItem) => {
            if (this.filterTag.length) {
              const tagIds = i.tags.map((t: Tag) => t.id)
              const filterTagIds = this.filterTag.map((t: Tag) => t.id)

              return _.intersection(tagIds, filterTagIds).length > 0
            }

            return true
          })
          .filter((i: FoodItem) => {
            if (this.filterText) {
              const name = i.name
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()

              const filterText = this.filterText
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()

              return name.includes(filterText)
            }

            return true
          })
          .sort((a: FoodItem, b: FoodItem) => a.name.localeCompare(b.name, 'sk')) // FIXME
          .value()
    }

    return []
  }

  checkForDuplicities(v: string): boolean | string {
    if (v && !this.isUpdate) {
      const value = v
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()

      const duplicateOf = this.itemCollection!.find(i => {
        const name = i.name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return i.id !== this.currentFoodItem!.id && name === value
      })

      return duplicateOf && this.$t('foodDatabasePage.foodAlreadyExistsMessage').toString() || true
    }

    return true
  }

  onCloseButtonClick(): void {
    this.closeDialog(this.selectedFood)
  }

  closeDialog(foodItem: FoodItem | null): void {
    this.$emit('closeDialog', foodItem)
    this.resetDialogState()
  }

  changeEnergyValue() {
    localStorage.setItem("energyUnit", this.energyValueStatus)
  }

  mounted(): void {
    if (this.currentFoodItem && this.currentFoodItem.id > 0) {
      this.selectedFood = this.currentFoodItem
      this.isUpdate = true
      this.selectedTagCollection = this.tagCollection!.filter(t => !!this.currentFoodItem.tags.find(it => it.id === t.id))
      this.foodItemName = this.currentFoodItem.name
      this.weight = this.currentFoodItem.weight
      if (this.currentFoodItem.energy !== null) {
        this.energyValue = this.currentFoodItem.energy.split(' ', 1).toString()
      }
      this.price = this.currentFoodItem.price
      this.text = this.currentFoodItem.description
      this.energyValueStatus = this.currentFoodItem.energyUnit
      this.selections.push.apply(this.selections, this.currentFoodItem.allergens)
      this.recipe = this.currentFoodItem.recipe
      if (this.$refs['foodForm']) {
        //@ts-ignore
        this.$refs['foodForm'].resetValidation()
      }
    } else {
      if (this.subGroupTags) {
        this.selectedTagCollection.push.apply(this.selectedTagCollection, this.isTagInSubgroup())
      }

      if (this.searchTerm) {
        this.foodItemName = this.searchTerm
      }
    }

  }
}
</script>

<style lang="stylus" scoped>

.inputFile
  display none

.image-wrapper
  position relative

.remove-button
  position: absolute;
  top: 8px;
  right: 3px;
  z-index: 100;
  background-color: darkgray;
  //padding: 4px 3px;

  color: #000;
  font-weight: bold;
  cursor: pointer;

.remove-button1
  position: absolute;
  top: 5px;
  right: 3px;
  z-index: 100;
  background-color: darkgray;
  //padding: 4px 3px;

  color: #000;
  font-weight: bold;
  cursor: pointer;
.image-shadow
  filter:grayscale(130%)
.reload-button-position
  margin-top -240px
  margin-left 22px
  z-index 200

.reload-button-position2
  margin-top -240px
  margin-left 5px
  z-index 200

.pointer
  cursor pointer
</style>